export type WorkTimePart = "hours" | "minutes" | "seconds";
export type WorkTimeParts = Record<WorkTimePart, number>;

export const splitWorkTime = (totalSeconds: number): WorkTimeParts => ({
  hours: Math.floor(totalSeconds / 3600),
  minutes: Math.floor((totalSeconds % 3600) / 60),
  seconds: totalSeconds % 60,
});

export const combineWorkTime = ({ hours, minutes, seconds }: WorkTimeParts) =>
  hours * 3600 + minutes * 60 + seconds;

export const updateWorkTimePart = (
  totalSeconds: number,
  part: WorkTimePart,
  value: number
) => combineWorkTime({ ...splitWorkTime(totalSeconds), [part]: value });
